import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute } from '@tanstack/react-router'
import { MapComparePage } from '~/components/routes/development/map-compare/map-compare-page'
import { FeatureRouteGuard } from '~/components/route-guards'

export const Route = createFileRoute('/_authenticated/development/map-compare')({
  component: MapCompareRoute,
})

/** Page de démo accessible uniquement par URL, derrière le flag Flipt `map-tiles-compare`. */
function MapCompareRoute() {
  return (
    <FeatureRouteGuard flag={FLAGS.mapTilesCompare}>
      <MapComparePage />
    </FeatureRouteGuard>
  )
}
